import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import { Check } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import Table from 'components/Table/Table';
import { wsUpdate } from 'services/WService';

const useStyles = makeStyles({
  ...styles,
  tableCell: {
    padding: '6px 8px!important',
  },
});

function PromotionBureaus(props) {
  const classes = useStyles();
  const { promotion, bureaus, setBureaus } = props;
  const statePromo = promotion.state == 'N' || promotion.state == 'G' ? false : true;

  async function updateBureau(promotionBureau) {
    let res = await wsUpdate(`prom/promotion/${promotion.id}/bureau`, promotionBureau.id, {
      state: promotionBureau.state === 'A' ? 'I' : 'A',
    });
    if (res.success) {
      setBureaus((bureaus) => {
        let newBureaus = [...bureaus];
        let index = newBureaus.findIndex((bureau) => bureau.id === promotionBureau.id);
        newBureaus[index].state = promotionBureau.state === 'A' ? 'I' : 'A';
        return newBureaus;
      });
    }
  }

  if (bureaus === undefined) return <></>;

  return (
    <GridItem xs={12}>
      <CardContainer title={'Mesas'}>
        <Table
          tableHead={['#', 'Zona', 'Mesa']}
          tableData={bureaus
          .filter((promotionBureau) => promotionBureau.zone && promotionBureau.bureau)
          .map((promotionBureau, i) => {
            return [
              <Fragment key={i}>
                <div
                  className={`${classes.checkboxAndRadio} ${classes.checkboxAndRadioHorizontal}`}
                >
                  <FormControlLabel
                    disabled={statePromo}
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => {
                          updateBureau(promotionBureau);
                        }}
                        checked={promotionBureau.state === 'A'}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                        }}
                        style={{ marginTop: 0 }}
                      />
                    }
                    classes={{
                      label: classes.label,
                      root: classes.labelRoot,
                    }}
                    label={i + 1}
                  />
                </div>
              </Fragment>,
              promotionBureau.zone?.description || 'Zona desactivada',
              promotionBureau.bureau?.description || 'Mesa desactivada',
            ];
          })}
        />
      </CardContainer>
    </GridItem>
  );
}

export default PromotionBureaus;
